import { RichTextField } from '@prismicio/client'

/**
 * Find the 1st anchor tag in RichTextField. This going to be used intially to extract the
 * href of a RickTextField that would only have 1 anchor tag
 */
export const getCTAHref = (field: RichTextField): string => {
  for (const subfield of field) {
    if (subfield.type === 'image' || subfield.type == 'embed') return ''
    else {
      // Find first anchor tag
      for (const span of subfield.spans) {
        if (span.type === 'hyperlink') return span.data.url || ''
      }
    }
  }
  return ''
}
